import styles from './index.module.css'
import classnames from 'classnames'

export const View = ({ label, className }) => {
    return (
        <div className={classnames(className, styles.default)}>
            <span>{label}</span>
        </div>
    )
}
